/**
 * 农行云闪付收银台。电脑把支付链接画成二维码；手机点「立即支付」才出链并跳转。
 */
import { executeNhBankPay, fetchNhBankCashierPage } from '@/api/api'
import { buildQrImageSrc } from '@/utils/qrRender'

export function isDesktopBrowser () {
  if (typeof navigator === 'undefined') return false
  const ua = (navigator.userAgent || '').toLowerCase()
  return !/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini|mobile/i.test(ua)
}

export function pickPayUrl (payload) {
  if (!payload) return ''
  const pay = String(payload.payUrl || payload.channelPayUrl || payload.codeUrl || '').trim()
  return /^https?:\/\//i.test(pay) ? pay : ''
}

export async function loadPageContext (orderId, token) {
  const ctx = await fetchNhBankCashierPage(orderId, token)
  if (!ctx) throw new Error('页面加载失败')
  return ctx
}

export async function requestExecute (orderId, token) {
  try {
    const d = await executeNhBankPay(orderId, token)
    if (!d) throw new Error('网络异常')
    return d
  } catch (err) {
    if (err && err.data) {
      const vo = err.data
      if (vo.expired) {
        const expiredErr = new Error(vo.message || '订单已过期')
        expiredErr.expiredPayload = vo
        throw expiredErr
      }
      throw new Error(vo.message || err.message || '出链失败')
    }
    throw new Error((err && err.message) || '出链失败')
  }
}

export function formatCountdown (leftMs) {
  const s = Math.max(0, Math.floor(leftMs / 1000))
  const h = String(Math.floor(s / 3600)).padStart(2, '0')
  const m = String(Math.floor((s % 3600) / 60)).padStart(2, '0')
  const sec = String(s % 60).padStart(2, '0')
  return h + ':' + m + ':' + sec
}

function nhBankQrPixelSize () {
  const vw = typeof window !== 'undefined' ? window.innerWidth : 390
  return Math.max(300, Math.min(360, Math.floor(vw * 0.86)))
}

export async function renderQrToElement (el, text) {
  if (!el || !text) return false
  const size = nhBankQrPixelSize()
  const src = await buildQrImageSrc(text, {
    pixelSize: size,
    errorCorrectionLevel: 'L',
    margin: 4
  })
  if (!src) return false
  el.innerHTML = ''
  const img = document.createElement('img')
  img.src = src
  img.width = size
  img.height = size
  img.alt = '云闪付二维码'
  img.style.maxWidth = '100%'
  img.style.height = 'auto'
  el.appendChild(img)
  return true
}
